import React, { useMemo } from 'react'
import { useState, useEffect, useRef } from 'react'
import { Portal } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../css/common/dropDown.scss'
import '../../css/modal.scss'
import { faCaretDown, faCaretUp, faSearch, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import { addPropToAllObj, findObjctByValueFromArrayOfObject, focusElemnt, removeByIndex, updatePropertyByIndex } from './helper'

const DropDownMultiSelectV2 = (props) => {
  const { id, label, defaultvalue=[], value, dataKey, idKey, data, searchPlaceholder,limit =1000} = props
  const { showActn, width, field, disabled, portal = false, crossIconId, nextId, prevId } = props
  const { autoFocus = false, tabIndex = undefined, onSelect = false, aligntOnTop = false, resetFlag = false, ...rest } = props
  const { selectionLabel = 'Multi Selected'} = props
  const [showDrop, setShowDrop] = useState(false)
  const [focus, setFocus] = useState(false)
  const [blur, setBlur] = useState(true)
  const [searchInput, setSearchInput] = useState('')
  const [dataCopy,setDataCopy] = useState(data);
  const [filteredLists, setFilteredLists] = useState(dataCopy)
  const [selectList, setSelectedList] = useState([])
  const [cursor, setCursor] = useState(0)
  const searchResultRef = useRef(null)
  const portalRef = useRef(null)
  const input1ref = useRef(null)
  const input2ref = useRef(null)
  const dropRef = useRef(null)
  const showDropRef = useRef(showDrop);
  const [dropPortalStyle, setDropPortalStyle] = useState({ width: 100, left: 0, top: 0, right: 'auto' })
  const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }
  useEffect(()=>{
    if (searchInput !== '') {
      const filterDataIndexes = []
      const filterData = dataCopy.filter((item, arr, key) => {
        const status = item[dataKey].toLowerCase().includes(searchInput.toLowerCase())
        if (status) {
          filterDataIndexes.push(key)
        }
        return status
      })
      setFilteredLists(filterData)
    } else {
      setFilteredLists(dataCopy)
    }
  },[dataCopy,searchInput])

  const previousData = usePrevious(defaultvalue)
  const computedDataCopy = useMemo(() => {
    const initializedData = addPropToAllObj(data, 'checked', false)
    const selectedValues = defaultvalue?.length ? defaultvalue : []
    return initializedData.map((item) => ({
      ...item,
      checked: selectedValues.some((val) => val[idKey] === item[idKey]),
    }))
  }, [defaultvalue, data])
  
  useEffect(() => {
    setDataCopy(computedDataCopy)
    setFilteredLists(computedDataCopy)
    setSelectedList(computedDataCopy.filter((item) => item.checked))
  }, [computedDataCopy])   
  useEffect(() => {
    if (autoFocus) {
      input1ref.current.focus()
    }
  }, [])
  useEffect(() => {
    if (showDrop && !disabled) {
      input2ref.current.focus()
    }
  }, [showDrop])
  useEffect(() => {
    showDropRef.current = showDrop; // Update ref whenever showDrop changes
  }, [showDrop]);
  
  useEffect(() => {
    // setting style of portal based on parents position in the dom
    if (portal) {
      const dims = dropRef.current.getBoundingClientRect()
      const style = {}
      // style.width = dims.width;
      style.width = 'max-content'
      style.top = aligntOnTop ? dims.top + window.scrollY - 210 : dims.top + window.scrollY + 34
      style.left = dims.left + window.scrollX
      setDropPortalStyle(style)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [dropRef, onSelect, selectList, portal, portalRef])

  const handleClickOutside = (e) => {
    if (
      !(
        (dropRef && dropRef.current && dropRef.current.contains(e.target)) ||
        (portal && portalRef && portalRef.current && portalRef.current.contains(e.target))
      ) &&
      showDropRef.current
    ) {
      setShowDrop(false)
      onSelect && onSelect(selectList)
    }
  }
  const scrollIntoView = (position) => {
    searchResultRef.current.parentNode.scrollTo({
      top: position,
      behavior: 'smooth',
    })
  }
  const showSuggestion = (e, el) => {
    e.stopPropagation()
    setShowDrop(true)
  }
  const hideSuggestion = (e, el) => {
    setShowDrop(false)
  }
  const focusNextElement = () => {
    focusElemnt(nextId)
  }
  const focusPrevElement = () => {
    focusElemnt(prevId)
  }
  const handleDropItem = (e, el) => {
    e.stopPropagation()
    setInpVal(el)
  }
  const searchItems = (searchValue) => {
    setSearchInput(searchValue)
    
  }
  
  
  const resetItem = () => {
    setSearchInput('')
    setSelectedList([])
  }

  const setInpVal = (val, triggerSelect = false) => {
    const index = dataCopy.findIndex((x) => x[dataKey] === val[dataKey])
    let newList = []
    if (index === 0 && rest.HasAllSelect) {
      if (dataCopy[index].checked) {
        setSelectedList([])
        newList = addPropToAllObj(dataCopy)
      } else {
        setSelectedList(dataCopy)
        newList = addPropToAllObj(dataCopy, true)
      }
    } else {
      if (dataCopy[index].checked) {
        const selectIndex = selectList.findIndex((x) => x[dataKey] === val[dataKey])
        setSelectedList(removeByIndex(selectList, selectIndex))
        const updatedList = updatePropertyByIndex(dataCopy, index)
        if (rest.HasAllSelect) {
          newList = updatePropertyByIndex(updatedList, 0, false)
        } else {
          newList = updatedList
        }
      } else {
        if (limit === 1) {
          setShowDrop(false)
          onSelect && onSelect([val])
        }
        if (selectList.length >= limit) return
        setSelectedList([...selectList, val])
        const updatedList = updatePropertyByIndex(dataCopy, index, true)
        if (rest.HasAllSelect && updatedList.slice(1).every((item) => item.checked)) {
          newList = updatePropertyByIndex(updatedList, 0, true)
        } else {
          newList = updatedList
        }
      }
    }
    setDataCopy(newList)
    if (triggerSelect) {
      onSelect(newList.filter((item) => item.checked))
    }
  }
  const prevFlag = usePrevious(resetFlag)
  useEffect(() => {
    if (resetFlag && resetFlag != prevFlag) {
      resetItem()
    }
  }, [resetFlag])

  useEffect(() => {
    if (cursor < 0 || cursor > filteredLists.length || !searchResultRef) {
      return () => {}
    }
    if (searchResultRef && searchResultRef.current && searchResultRef.current.children) {
      let listItems = Array.from(searchResultRef.current.children)
      listItems[cursor] && scrollIntoView(listItems[cursor].offsetTop - 40)
    }
  }, [cursor])

  const keyboardNavigation1 = (e) => {
    if (e.key === 'ArrowDown') {
      showSuggestion(e)
    }
    if (e.key === 'ArrowUp') {
      showSuggestion(e)
    }
    if (e.key === 'Escape') {
      focusPrevElement()
    }
    if (e.key === 'Enter') {
      focusNextElement()
    }
  }
  const keyboardNavigation2 = (e) => {
    if (e.key === 'ArrowDown') {
      showDrop ? setCursor((c) => (c < filteredLists.length - 1 ? c + 1 : 0)) : showSuggestion()
    }
    if (e.key === 'ArrowUp') {
      setCursor((c) => (c > 0 ? c - 1 : 0))
    }

    if (e.key === 'Escape') {
      hideSuggestion()
      input1ref.current.focus()
    }

    if (e.key === 'Enter' && cursor > -1) {
      setInpVal(filteredLists[cursor],true)
      hideSuggestion()
      nextId ? focusNextElement() : input1ref.current.focus()
    }
  }
  const labelTxyt =
    field === 'compulsory' ? (
      <span>
        {label}
        <span style={{ color: 'red', paddingLeft: '5px' }}>*</span>
      </span>
    ) : (
      label
    )

  const dropDownRenderer = (props) => (
    <div className="drop--wrapper" style={!!portal ? dropPortalStyle : {}}>
      <div className="drop--search">
        <input
          ref={input2ref}
          type="text"
          className="search"
          placeholder={searchPlaceholder}
          value={searchInput}
          autoComplete="off"
          onChange={(e) => searchItems(e.target.value)}
          onKeyDown={(e) => keyboardNavigation2(e)}
          onFocus={() => {
            setFocus(true)
            setBlur(false)
          }}
          onBlur={() => {
            setBlur(true)
            setFocus(false)
          }}
        />
        <div className="search--icon">
          <FontAwesomeIcon icon={faSearch} color={'#777'} />
        </div>
      </div>
      <div className="drop--content scroll">  
        <ul className="list-group" ref={searchResultRef}>
          {filteredLists.length > 0 ? (
            filteredLists.map((el, index) => (
              <li
                key={`drop--item_${el[dataKey]}_${el[idKey]}}`}
                className={`drop--item ${el?.checked ? 'selected' : ''} ${cursor === index ? 'highlighted' : ''}`}
                onClick={(e) => handleDropItem(e, el)}
              >
                <div className={`search--checkbox ${el?.checked ? 'checked' : ''}`}>
                  {
                    <span className="check">
                      <FontAwesomeIcon icon={faCheck} color={'#fff'} />
                    </span>
                  }
                </div>
                <div>{el[dataKey]}</div>
              </li>
            ))
          ) : (
            <div className="not--found">No results found</div>
          )}
        </ul>
      </div>
    </div>
  )



  return (
    <div
      className={`dropdown--wrapper ${disabled ? 'disabled-wrapper' : ''} ${showDrop ? 'active' : ''}`}
      style={{ width: width, minWidth: rest.minWidth }}
      ref={dropRef}
    >
      <input
        type="text"
        className={`inp--field ${disabled ? 'disable' : ''} ${focus ? 'active' : ''}`}
        value={value ? value : selectList.length > 1 ? selectionLabel : selectList.length > 0 ? selectList?.[0][dataKey] : ''}
        readOnly
        onClick={showSuggestion}
        onKeyDown={keyboardNavigation1}
        tabIndex={tabIndex}
        id={id}
        ref={input1ref}
      />
      {!disabled && (
        <div className="cross--icon" onClick={resetItem} id={crossIconId}>
          <span className="cross">
            <FontAwesomeIcon icon={faXmark} color={'#777'} />
          </span>
        </div>
      )}
      {!showActn && !disabled ? (
        <div className="caret--icon">
          {showDrop ? <FontAwesomeIcon icon={faCaretUp} color={'#777'} /> : <FontAwesomeIcon icon={faCaretDown} color={'#777'} />}
        </div>
      ) : (
        ''
      )}
      <div className={`inp--label ${focus ? 'active' : selectList.length && blur ? ' filled' : ''}`}>{labelTxyt}</div>
      {/* <div className={`inp--label`}>{labelTxyt}</div> */}

      {!disabled &&
        // For portal using portal value else whatever was earlier will be rendered
        // added parent class name as styles were dependent on that
        (!!portal ? (
          <Portal container={document.getElementById('root')}>
            <div className="dropdown--wrapper dropdown--wrapper--portal" ref={portalRef} style={{ display: showDrop ? 'block' : 'none' }}>
              {dropDownRenderer()}
            </div>
          </Portal>
        ) : (
          <div className="dropdown--wrapper dropdown--wrapper--portal" ref={portalRef} style={{ display: showDrop ? 'block' : 'none' }}>
            {dropDownRenderer()}
          </div>
        ))}
    </div>
  )
}

export default DropDownMultiSelectV2
